/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";

import Stack from "@mui/material/Stack";
import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Div from "@jumbo/shared/Div";
import Loader from "@jumbo/components/Loader";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { useDispatch, useSelector } from "react-redux";

import { getVariantLowStockList } from "app/redux/slice/variantLowStockSlice";
import axios from "axios";

const ProductVariantLowStock = () => {
  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();

  const variantData = useSelector((state) => state?.variantLowStock);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "variant" });

  const columns = [
    { id: "productName", label: "Product Name", sort: true },
    { id: "sku", label: "SKU", sort: true },
    { id: "color", label: "Color", render: (elm) => elm?.color?.name },
    { id: "price", label: "Price" },
    { id: "quantity", label: "Qty", sort: true },
    {
      id: "lowStock",
      label: "Low Stock",
      sort: true,
      render: (elm) => elm?.lowStock || 0,
    },
    { id: "processQty", label: "Process Qty", sort: true },
  ];

  const getData = () => {
    localStorage.setItem("variant-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getVariantLowStockList(value));
  };

  // Download CSV from API by sending csv=1 as a query param
  const downloadCsv = async () => {
    const params = {
      search: searchText.trim(),
    };
    if (orderBy !== "") {
      params.sort = order === "asc" ? 1 : -1;
      params.field = orderBy;
    }
    params.csv = 1; // tell the API to return CSV

    try {
      const response = await axios.get("variant/low-stock", {
        params,
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "text/csv",
      });

      // try to get filename from content-disposition
      let filename = "low_stock.csv";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
        );
        if (match != null && match[1]) filename = match[1].replace(/['"]/g, "");
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("CSV download failed:", error);
      alert("CSV download failed. Please try again.");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  return (
    <>
      {variantData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <Button
                      fullWidth
                      type="button"
                      variant="outlined"
                      onClick={() => {
                        downloadCsv();
                      }}
                    >
                      Download CSV
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Low Stock Product List
                </Typography>
              </Stack>
              <Table
                columns={columns}
                rows={variantData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={variantData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

export default ProductVariantLowStock;
